import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  open: false
};

const proExitModalSlice = createSlice({
  name: 'pro-exit-modal',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    }
  }
});

export const { setOpen } = proExitModalSlice.actions;
export const proExitModalReducer = proExitModalSlice.reducer;
